import React, { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

const stats = [
  {
    value: 94,
    en: "of Indian CEOs believe personal relationships are the key to business success",
    hi: "भारतीय सीईओ मानते हैं कि निजी रिश्ते व्यापार की सफलता की कुंजी हैं",
  },
  {
    value: 62,
    en: "of people prefer purchasing corporate gifts that are proudly Made in India",
    hi: "लोग भारत में बने कॉर्पोरेट उपहार खरीदना पसंद करते हैं",
  },
];

const Percent = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const c = animate(0, value, { duration: 1.8, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(v) });
    return () => c.stop();
  }, [inView, value]);
  return (
    <span ref={ref}>
      {Math.round(n)}
      <span className="text-[#F3E5AB]">%</span>
    </span>
  );
};

const Relationships = () => {
  return (
    <section className="relative z-10 overflow-hidden bg-[#0B0F19] py-24 md:py-32" data-testid="relationships-section">
      <div className="pointer-events-none absolute right-[-8%] top-1/4 h-[460px] w-[460px] bloom-crimson opacity-40" />
      <div className="pointer-events-none absolute left-[-6%] bottom-0 h-[420px] w-[420px] bloom-indigo opacity-50" />

      <div className="mx-auto max-w-4xl px-6 text-center md:px-10">
        <motion.span
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37]"
        >
          More than gifts
        </motion.span>

        {/* Hindi headline */}
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mx-auto mt-5 max-w-3xl font-serif text-4xl leading-[1.15] tracking-tight text-[#F3EEE3] md:text-6xl"
          data-testid="relationships-hindi-heading"
          lang="hi"
        >
          रिश्ते ही सबसे बड़ा{" "}
          <span className="italic text-[#D4AF37]">उपहार</span> हैं
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mx-auto mt-5 max-w-2xl font-sans text-base leading-relaxed text-[#A9B0C2]"
        >
          Corporate gifting isn’t a transaction — it’s how great businesses nurture
          trust. B2B gifting plays a vital role in strengthening every connection.
        </motion.p>
      </div>

      <div className="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-6 px-6 md:grid-cols-2 md:px-10">
        {stats.map((s, i) => (
          <motion.div
            key={s.value}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl border border-[#F3E5AB]/10 bg-[#111826] p-10 text-center transition-colors duration-300 hover:border-[#D4AF37]/40"
            data-testid={`relationship-stat-${i}`}
          >
            <div className="font-serif text-6xl font-medium tracking-tight text-[#D4AF37] md:text-7xl">
              <Percent value={s.value} />
            </div>
            <p className="mx-auto mt-5 max-w-sm font-sans text-sm leading-relaxed text-[#E8E2D0]">{s.en}</p>
            <p className="mx-auto mt-3 max-w-sm font-sans text-xs leading-relaxed text-[#8B93A7]" lang="hi">
              {s.hi}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Relationships;
